import { request_list } from '@/commons/hpod';
import Vue from 'vue';
const viewTitle = 'dashboard'
// initial state
const state = {
    loading: false,
    three_month_report: {},
    sale_monthly_report: {},
    sale_warning_report: {},
    debt_summary: {},
    truck_status_chart: [],
    order_status_chart: []
};

// getters
const getters = {};

// actions
const actions = {
    get_3month_report({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list('dashboard/three-month-report', data => {
            commit('set_3month_report', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    get_sale_monthly_report({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list('dashboard/sale-monthly-report', data => {
            commit('set_sale_monthly_report', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    get_sale_warning_report({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list('dashboard/sale-warning-report', data => {
            commit('set_sale_warning_report', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    getDebtSummary({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list('dashboard/debt-summary', data => {
            commit('setDebtSummary', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    getTruckStatusChart({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list('dashboard/truck-status-chart', data => {
            commit('setTruckStatusChart', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
    getOrderStatusChart({ commit }, param) {
        commit("setLoading", { loading: true });
        request_list('dashboard/order-status-chart', data => {
            commit('setOrderStatusChart', data);
            commit("setLoading", { loading: false });
        }, Vue.http, param, this.state.authentication.token);
    },
};

// mutations
const mutations = {
    set_3month_report(state, data) {
        state.three_month_report = data;
    },
    set_sale_monthly_report(state, data) {
        state.sale_monthly_report = data;
    },
    set_sale_warning_report(state, data) {
        state.sale_warning_report = data;
    },
    setDebtSummary(state, ret) {
        state.debt_summary = ret.data;
    },
    setTruckStatusChart(state, ret) {
        state.truck_status_chart = ret.data;
    },
    setOrderStatusChart(state, ret) {
        state.order_status_chart = ret.data;
    },
    setLoading(state, { loading }) {
        state.loading = loading;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
